export default __webpack_public_path__ + "static/cs-deloitte--mobile-3a1601bc5418791358ede20ad4a920de.png";